import type { EmptyStateProps, ErrorBlockProps, LoadingRowProps } from './types';

export const LoadingRow = ({ label }: LoadingRowProps) => (
  <div className="syntax-status">
    <span className="ann-btn-spinner" />
    {label}
  </div>
);

export const ErrorBlock = ({ message, onRetry }: ErrorBlockProps) => (
  <div className="syntax-error-block">
    <div>{message}</div>
    <button className="btn-review-action" onClick={onRetry}>Retry</button>
  </div>
);

export const EmptyState = ({ message }: EmptyStateProps) => (
  <div className="syntax-empty">{message}</div>
);

export const IdleState = () => (
  <div className="syntax-idle">Choose a scope above and run the check.</div>
);
